import React, { useEffect, useState, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { Button, Modal, Form, Row, Col, InputGroup } from "react-bootstrap";
import { Paper, Grid, TextField } from '@material-ui/core';
import { DataGrid } from '@material-ui/data-grid';
import { ToastContainer, Flip } from "react-toastify";
import SearchIcon from '@material-ui/icons/Search';
import ClearIcon from '@material-ui/icons/Clear';
import Alert from '@material-ui/lab/Alert';
import * as Admin from "../../../store/ducks/admin.duck";
import * as Reference from "../../../store/ducks/reference.duck";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import Autocomplete from '@material-ui/lab/Autocomplete';
import "react-toastify/dist/ReactToastify.css";
import 'bootstrap/dist/css/bootstrap.min.css'
import '../../../../_metronic/_assets/css/app2.css';

export default function Referrers() {

  const dispatch = useDispatch()

  useEffect( () => { dispatch(Admin.actions.fetchCsAgents()) }, [dispatch] )
  useEffect( () => { dispatch(Reference.actions.fetchTimeZone()) }, [dispatch] )
  useEffect( () => { dispatch(Admin.actions.fetchCsCentres()) }, [dispatch] )

  const userTZ = useSelector(state => state.auth.userTZ)
  const timeZone = useSelector(state => state.reference.TimeZone)
  const filters = useSelector(state => state.admin.Filters)
  const csAgents = useSelector(state =>  state.admin.CsAgents)
  const csCentres = useSelector(state => state.admin.CsCentres)
  const filteredCsAgents = csAgents.filter(agent => (agent.fullname.toLowerCase().search(filters.referrersTerm.toLowerCase()) > -1 || filters.referrersTerm.length === 0))
  const role = useSelector(state =>  state.auth.roleDesc)

  var [showCsAgent, setShowCsAgent] = useState(false)
  var [csAgentError, setCsAgentError] = useState('')

  function handleCsAgentClose() {
    setShowCsAgent(false);
  }  

  function loadNewCsAgent() {
    setcurrentModalHeader('Adding CS Staff');
    setcurrentPasswordHeader('Please enter password for new login');
    setcurrentID(0);
    setcurrentFirstName('');
    setcurrentSurname('');
    setcurrentEmail('');
    setcurrentMobile('');
    setcurrentCsCentre(initCsCentre());
    setcurrentAdmin('No');
    setcurrentStatus('Active');
    setCsAgentError('');
    setShowCsAgent(true);
    setcurrentNewPassword(null);
    setcurrentNewPasswordConfirmation(null);
    setcurrentTimeZone('AUS Eastern Standard Time');
    setcurrentNewPasswordConfirmation()
  }

  const initCsCentre = useCallback(() => {
    return {
      id: 0,
      centerName: 'Select Centre',
      email: '',
      phone: '',
      fax: '',
      contact: '',
      contactEmail: '',
      contactPhone: '',
      fullAddress: '',
      postCode: '',
      longitude: '',
      latitude: '',
      website: '',
      practiceType: ''
    }
  },[])

  function handleTimeZoneAutocompleteChange(propertyName, event, newValue) { 
    if (newValue) {
      setcurrentTimeZone(newValue.systemName);
    }
  } 


  const loadCsCentre = useCallback((thisCsCentre) => {
    setcurrentCsCentre(thisCsCentre ? thisCsCentre : initCsCentre())
  }, [initCsCentre])

  const loadExistingCsAgent = (thisCsAgent) => {
    setcurrentModalHeader('Updating ' + thisCsAgent.firstname + ' ' + thisCsAgent.surname);
    setcurrentPasswordHeader('Password Update (Leave blank unless resetting)');
    setcurrentID(thisCsAgent.id);
    setcurrentFirstName(thisCsAgent.firstname);
    setcurrentSurname(thisCsAgent.surname);
    setcurrentEmail(thisCsAgent.email);
    setcurrentMobile(thisCsAgent.mobilephone);
    // 
    setcurrentCsCentre(csCentres.find(centre => centre.id === thisCsAgent.csCentreID))
    //
    setcurrentStatus(thisCsAgent.status);
    setcurrentTimeZone(thisCsAgent.timezone);
    setcurrentAdmin(thisCsAgent.admin);
    setcurrentNewPassword(null);
    setcurrentNewPasswordConfirmation(null);
    setCsAgentError('');
    setShowCsAgent(true);
  }

  const getCsCentreOption = (option, value) => {
    if (option.id === value.id) {
      return option
    } else {
      return initCsCentre();
    }
  }


  function postCsAgent() {
    let validation = true;
    // Check if passwords are the same
    if (currentNewPassword)
    {
      // Check passwords are the same
      if (currentNewPassword !== currentNewPasswordConfirmation)
      {
        setCsAgentError('Passwords do not match')
        validation = false;
      } 
    }
    if (currentFirstName === ''|| currentSurname === '' || currentEmail === '' || currentMobile === '' || currentCsCentre === '' || currentCsCentre.id === 0) 
    { 
      setCsAgentError('You must complete all manadatory* fields.')
      validation = false;
    } 
    //
    // Submit if no errors 
    if (validation)
    {
      setCsAgentError('')
      var payload = {
        id: currentID,
        firstname: currentFirstName,
        surname: currentSurname,
        email: currentEmail,
        mobilephone: currentMobile,
        csCentreID: currentCsCentre.id,
        admin: currentAdmin,
        status: currentStatus,
        timezone: currentTimeZone,
        newpassword: currentNewPassword,
        newpasswordconfirmation: currentNewPasswordConfirmation
      }
      dispatch(Admin.actions.putCsAgent(payload));
      setShowCsAgent(false)
    }
  }

  var [currentID,setcurrentID] = useState();
  var [currentFirstName,setcurrentFirstName] = useState();
  var [currentSurname,setcurrentSurname] = useState();
  var [currentEmail,setcurrentEmail] = useState();
  var [currentMobile,setcurrentMobile] = useState();
  var [currentCsCentre,setcurrentCsCentre] = useState(initCsCentre());
  var [currentNewPasswordConfirmation,setcurrentNewPasswordConfirmation] = useState();
  var [currentNewPassword,setcurrentNewPassword] = useState();
  var [currentStatus,setcurrentStatus] = useState(); 
  var [currentModalHeader,setcurrentModalHeader] = useState(); 
  var [currentPasswordHeader,setcurrentPasswordHeader] = useState();
  var [currentTimeZone, setcurrentTimeZone] = useState(userTZ ? userTZ : 'AUS Eastern Standard Time');
  var [currentAdmin, setcurrentAdmin] = useState('No');

  const columns = [
    { field: 'id', headerName: 'ID', hide: true },
    { field: 'fullname', headerName: 'Name', width: 190,
    renderCell: (params) => (
      <strong>
        <div onClick={() => loadExistingCsAgent(csAgents.find(agent => agent.id === params.row.id))} className="cell-Link">
          {params.value}
        </div>
      </strong>
    ),  },
    { field: 'email', headerName: 'Email', width: 220,
      renderCell: (params) => (
        <CopyToClipboard text={params.row.email}>
          <span  className="cell-Link" style={{ fontWeight: 500}}>{params.row.email}</span>
        </CopyToClipboard>
      ) 
    },
    { field: 'mobilephone', headerName: 'Phone', width: 110 },
    { field: 'csCentreName', headerName: 'Centre Name', width: 250 },
    { field: 'status', headerName: 'Status', width: 115 }    
  ];


  return (
    <>
      <h4>
        Centralised Service Staff
      </h4>
      <Paper> 
        <Grid container justifyContent="space-between" style={{ padding: 10 }}>
            <Grid item style={{ marginTop: 2, marginLeft: 2 }}> 
              <Grid container>
                <Grid item>             
                  <InputGroup size="sm">
                    <InputGroup.Prepend>
                      <InputGroup.Text>
                        <SearchIcon fontSize="small" style={{ marginLeft: -4 }} />
                      </InputGroup.Text>
                    </InputGroup.Prepend>
                    <Form.Control                  
                        type="text"
                        value={filters.referrersTerm}
                        onChange={(event) => dispatch(Admin.actions.setFilters({ filterName: 'referrersTerm', filterValue: event.target.value }))}
                        autoComplete='OFF'
                        style={{ maxWidth: 170, height: 35, backgroundColor: filters.referrersTerm.length > 0 ? 'rgb(250 239 195)' : 'white' }}
                      />
                    <InputGroup.Append onClick={() => dispatch(Admin.actions.setFilters({ filterName: 'referrersTerm', filterValue: '' }))}>
                      <InputGroup.Text>
                        <ClearIcon fontSize="small" style={{ color: filters.referrersTerm.length > 0 ? '#222222' : 'silver', marginLeft: -3 }} />
                      </InputGroup.Text>
                    </InputGroup.Append>
                  </InputGroup>
                </Grid>
              </Grid>
          </Grid>
          <Grid item style={{ marginLeft: 20, marginRight: 10 }}>
            <Button variant="primary" size="sm" onClick={() => loadNewCsAgent()} style={{ marginRight: 20 }}>
              Add Staff
            </Button>
          </Grid>
        </Grid>
      </Paper>

      <Paper style={{ height: 700 }}>
        <DataGrid rows={filteredCsAgents} columns={columns} pageSize={10} rowsPerPageOptions={[10]} checkboxSelection={false} sortModel={[{ field: 'fullname', sort: 'desc' }]}  />
      </Paper>

      <Modal show={showCsAgent} onHide={handleCsAgentClose} dialogClassName="invite-modal">
        <Modal.Header closeButton className="invite-modal">
          <Modal.Title>{currentModalHeader}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="invite-modal">
          {csAgentError !== '' ?
          <Alert severity="error" style={{ marginBottom: 14 }}>
            {csAgentError}
          </Alert>
          :
          null }
          <h4>Personal Details</h4>
          <Row>
            <Col md="6">
              <Form.Group >
                <Form.Label>First Name*</Form.Label>
                <Form.Control type="text" name="profileFirstName" defaultValue={currentFirstName} onBlur={(event) => setcurrentFirstName(event.target.value)} autoComplete='new-password' />
              </Form.Group>
            </Col>
            <Col md="6">
              <Form.Group >
                <Form.Label>Surname*</Form.Label>
                <Form.Control type="text"  name="profileSurname" defaultValue={currentSurname} onBlur={(event) => setcurrentSurname(event.target.value)} autoComplete='new-password' />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md="6">
              <Form.Group >
                <Form.Label>Email*</Form.Label>
                <Form.Control type="text" name="profileEmail" defaultValue={currentEmail} onBlur={(event) => setcurrentEmail(event.target.value)} autoComplete='new-password' />
              </Form.Group>
            </Col>
            <Col md="6">
              <Form.Group >
                <Form.Label>Mobile Phone Number*</Form.Label>
                <Form.Control type="text" name="profileMobile" defaultValue={currentMobile} onBlur={(event) => setcurrentMobile(event.target.value)} autoComplete='new-password' />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md="6">
              <Form.Group style={{width: "100%"}}>
                <Form.Label>TimeZone</Form.Label>
                <Autocomplete
                  id="profileTimeZone"
                  variant="outlined"
                  options={timeZone}
                  getOptionLabel={(option) => option.name}
                  value={timeZone.find(v => v.systemName === currentTimeZone) || ''}
                  onChange={(event, newValue) => handleTimeZoneAutocompleteChange('profileTimeZone', event, newValue)}
                  style={{ fullWidth: true, display: 'flex', wrap: 'nowrap',  }}
                  renderInput={(params) => 
                    <TextField 
                      {...params} 
                      type="text"
                      variant="outlined"
                      margin="dense"
                      name="TimeZoneSelector"
                      style={{backgroundColor: "white", margin: 0, padding: 0}}
                      inputProps={{
                        ...params.inputProps,
                        autoComplete: 'new-password'}}
                    />}
                />
              </Form.Group>
            </Col>
          </Row>
          <h4>Centre</h4>
          <Row>
            <Col md="9">
              <Form.Group style={{width: "100%"}}>
                  <Form.Label style={{ color: 'green', fontWeight: 500 }}>Centre*</Form.Label>  
                  <Autocomplete
                      id="currentCsCentreID"
                      variant="outlined"
                      options={csCentres}
                      getOptionLabel={(option) => option.centerName}
                      getOptionSelected={(option, value) => getCsCentreOption(option, value)}
                      value= {currentCsCentre}
                      onChange={(event, newValue) => loadCsCentre(newValue)}
                      style={{ minWidth: 200, fullWidth: true, display: 'flex', wrap: 'nowrap',  }}
                      renderInput={(params) => 
                      <TextField 
                          {...params} 
                          type="text"
                          variant="outlined"
                          margin="dense"
                          name="currentCsCentreID"
                          style={{ backgroundColor: "white", margin: 0, padding: 0, maxWidth: 600  }}
                          inputProps={{
                          ...params.inputProps,
                          autoComplete: 'new-password'}}
                      />}
                  />
              </Form.Group>
            </Col>
          </Row>
          {role === 'Admin' ?
            <Row>
              <Col md="4">
                <Form.Group >
                  <Form.Label>Admin Access for this Centre</Form.Label>
                  <Form.Control as="select" defaultValue={currentAdmin} onBlur={(event) => setcurrentAdmin(event.target.value)}>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </Form.Control>
                </Form.Group>
              </Col>
            </Row>  
          :
            null
          }
          <h4>{currentPasswordHeader}</h4>
          <Row>
            <Col md="6">
              <Form.Group >
                <Form.Label>New Password</Form.Label>
                <Form.Control type="password" name="newpassword" defaultValue={currentNewPassword} onBlur={(event) => setcurrentNewPassword(event.target.value)} autoComplete='new-password' />
              </Form.Group>
            </Col>
            <Col md="6">
              <Form.Group >
                <Form.Label>New Confirm Password</Form.Label>
                <Form.Control type="password" name="newpasswordconfirmation" defaultValue={currentNewPasswordConfirmation} onBlur={(event) => setcurrentNewPasswordConfirmation(event.target.value)} autoComplete='new-password' />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md="6">
              <Form.Group >
                <Form.Label>Status</Form.Label>
                <Form.Control as="select" defaultValue={currentStatus} onBlur={(event) => setcurrentStatus(event.target.value)}>
                  <option value="Active">Active</option>
                  <option value="Archived">Inactive</option>
                </Form.Control>
              </Form.Group>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer className="invite-modal">
          <Button variant="secondary" onClick={handleCsAgentClose}>
            Close
          </Button>
          <Button variant="primary" onClick={postCsAgent}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>

      <div style={{border: "solid rgb(215, 215, 215) 1px", borderRadius: "4px",  backgroundColor: "white"}}>
        
        <ToastContainer
          position="bottom-right"
          transition={Flip}
          hideProgressBar={true}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    </>
  )
}

